import LogoLink from './LogoLink';

export default LogoLink;
